import { Component, OnInit, Input, ViewChild, ElementRef } from '@angular/core';
import { AuthenticationService } from '@app/core/authentication/authentication.service';
import { BaseAPIService } from '../../Services/api.base.service';
import { UtilService } from '../../Services/util.service';
import { FiledownloadService } from '../../Services/filedownload.service';
import { Chart, StockChart } from 'angular-highcharts';
import { ITelemetryLatestData } from '../../Models/ITelemetryLatestData';
import { ITelemetryData } from '@app/Models/ITelemetryData';
import { MessageService } from 'primeng/api';
import { ITagDetails } from '@app/Models/ITagDetails';
import { label } from '../../constants/labels';
import { DatePipe } from '@angular/common';
import { EMPTY, forkJoin, Observable, of, Subject, Subscription, timer } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';
import { message } from '@app/constants/messages';
import { environment } from '@env/environment';
import Highcharts from 'highcharts';
import xrange from "highcharts/modules/xrange";
import { IRule } from '../../Models/IRule';
import { ValidateRulesService } from '@app/shared/validate-rules.service';
import { rolesdef } from '@app/constants/role-def';
import { INotifyName } from '../../Models/INotifyTo';
import { IRulesDetail } from '../../Models/IRulesDetail';
import { IGridCols } from '../../Models/IGridCols';
import { TelemetryService } from '../../Services/telemetry.service';
import { delay } from 'rxjs/operators';
xrange(Highcharts);



@Component({
  selector: 'app-telemtry-data',
  templateUrl: './telemetry-data.component.html',
  styleUrls: ['../telemetry.component.scss'],
  providers: [MessageService]
})
export class TelemetryDataComponent implements OnInit {
  @ViewChild(('filtr')) filtr: ElementRef;
  @ViewChild(('dialogFiltr')) dialogFiltr: ElementRef;
  @Input() Schart: Chart;
  @Input() chartjson: any;
  @Input() Hchart: StockChart;
  chart: Chart;
  boolStock: Chart;
  messages: any;
  showAlarmModal: boolean = false;
  latestTelemetryGridcols: Array<IGridCols>;
  resourcecols: Array<IGridCols>;
  telemetryGridcols: Array<IGridCols>;

  latestTelemetryData: ITelemetryLatestData[];
  telemetryData: ITelemetryData[];
  contentData: any;
  seriesData = new Array<any>();
  flagSeriesData = new Array<any>();
  valuesSeriesData = new Array<any>();
  selectedDate: Date;
  chartogrid: boolean;
  gridtochart: boolean;
  noData: boolean = false;
  noDataG: boolean = false;
  tag: string;
  cooler_uid: string;
  singleResourceDayData: any;
  isDay: boolean;
  isWeek: boolean;
  isMonth: boolean;
  tagDetails: ITagDetails = { tag: '', cooler_uid: '' };
  labels: any;
  isPaginationL: boolean = true;
  isPaginationD: boolean = true;
  selResourceData: string = "";
  selectedDongleUId: string = "";
  selectedResources: string[] = [];
  flagResources: string[] = [];
  unitResources: string[] = [];
  checked: boolean = false;
  telemetryDataone: any[];
  request: {};
  request1: {};
  request2: {};
  request3: {};
  request4: {};
  request5: {};
  response: any[];
  date_d: any;
  notChanged: boolean = true;
  date_selected: Date;
  diffDays: number;
  isLoading: boolean;
  editFlag: boolean;
  last_connected_on: string;
  subscription: Subscription;
  scheduledInterval: Observable<number> = timer(0, environment.telemetryRefresh);
  showDetails: Boolean = true;
  showResourceData: Boolean = false;
  singleResourceDayDataNotExists: Boolean = false;
  targetSearch: string;
  dialogTargetSearch: string;
  newRule: IRule = { id: 0, alarmName: '', coolerId: 0, resourceId: 0, highlimit: 0, lowlimit: 0, notifiedTo: '', notifiedToList: [], severity: 0, isActive: true, addedBy: this.auth.authenticatedUserId, delayTimer: null };
  formInvalid: boolean;
  contentHeader: string = ''
  SelectedResourceId: number = 0;
  minVal: number;
  maxVal: number;
  notifiedTo: string;
  severity: number = 1;
  alarmRuleName: string;
  ruleId: Number;
  selectedRes: any;
  roles: any;
  roleCd: string;
  CanOnlySelectThemself: boolean = false;
  applyToNotifyToData: INotifyName[] = [];
  applyToNotifyName: any[] = [];
  isEdit: boolean = false;
  currentRule: IRulesDetail = { id: 0, coolerId: 0, delayTimer: null, resourceName: '', alarmName: '', isActive: true, resourceId: 0, highlimit: 0, lowlimit: 0, notifiedTo: '', notifiedToList: [], severity: 0 };
  showAlarmWhen: boolean = false;
  alarmWhenList: any;
  delay: number = null;
  selectedalarmWhen: any = 0;
  selectedContrl: any;
  isAlarmActive: boolean = false;
  delayLimitNonPostiveError: string = '';
  colIndex: number;
  dataSeriesFrmDflApi: string = '/Telemetry/DataSeriesFromDFL'
  borderBottom: string = '2px solid #3DCD58'
  delayMultiple: number = 0;
  enableExport = false;

  displayInputBoxs: boolean = false;
  emialIds: string[] = [];
  defaultLoggedInEmail: string;
  unit:string;

  constructor(private readonly baseService: BaseAPIService, private readonly auth: AuthenticationService, private readonly _validateService: ValidateRulesService,
    private readonly telemetryService: TelemetryService, private readonly messageService: MessageService, private readonly fileDownloadService: FiledownloadService, private readonly date: DatePipe, private readonly utilService: UtilService, private readonly translate: TranslateService) { }

  ngOnInit(): void {
    
   
    this.editFlag = false;
    this.messages = message;
    this.labels = label;
    this.isDay = true;
    this.isMonth = false;
    this.isWeek = false;
    this.selectedResources = [];
    this.telemetryData = [];
    this.isLoading = false;
    this.tag = this.telemetryService.Tag
    this.formInvalid = true;
    this.cooler_uid = this.telemetryService.dongleUId
    this.tagDetails.cooler_uid = this.cooler_uid;
    this.tagDetails.tag = this.tag;
    this.last_connected_on = this.telemetryService.cooler_lastConnectedOn;
    this.selectedDate = new Date(this.last_connected_on);
    this.roles = rolesdef;
    this.roleCd = this.auth.authenticatedRoleCd;
    
    this.isEdit = false;
    this.alarmWhenList = [
      { desc: '0', value: 0 },
      { desc: '1', value: 1 },
    ]
    this.latestTelemetryGridcols = [
      { field: 'resourceId', header: this.labels.tableHeaderResources, display: 'none', dataType: 'string' },
      { field: 'resourceName', header: this.labels.tableHeaderResources, width: '26%', display: 'auto', dataType: 'string' },
      { field: 'timeStamp', header: this.labels.tableHeaderTimeStamp, width: '35%', display: 'auto', dataType: 'date' },
      { field: 'value', header: this.labels.tableHeaderValue, width: '15%', display: 'auto', dataType: 'string' },
      { field: 'unit', header: this.labels.tableHeaderUnit, width: '12%', display: 'auto', dataType: 'string' }
    ];
    this.GetUserDetails();
    this.subscription = this.scheduledInterval.subscribe(() => {
      this.getLatestTelemetryData(this.cooler_uid);
    });

    this.chartogrid = false;
    if (this.filtr !== null && this.filtr !== undefined) {
      setTimeout(() => {
        this.filtr.nativeElement.dispatchEvent(new Event('input'));
      }, 0);
    }
    if (this.dialogFiltr !== null && this.dialogFiltr !== undefined) {
      setTimeout(() => {
        this.dialogFiltr.nativeElement.dispatchEvent(new Event('input'));
      }, 0);
    }

  }
  public getChartColor() {
    const colorArray: Array<any> = ['#D35400', '#56B4E9', '#228833', '#AA4499', '#A845FF', '#FF0000', '#FF7EB5', '#FFA500'];
    return colorArray;
  }
  public InitGraph(valuesSeriesData: Array<any>, flagSeriesData: Array<any>) {

    const boolFlagSeriesData: Array<any> = []
    const boolValuesSeriesData: Array<any> = valuesSeriesData;
    const boolCategory: Array<string> = [];
    let colorIndex = 0;
    const colorArray: Array<any> = this.getChartColor();
    for (let i = 0; i < flagSeriesData.length; i++, colorIndex++) {

      boolCategory.push(flagSeriesData[i].name);
      const JsonObj = {
        name: flagSeriesData[i].name,
        type: "xrange",
        yAxis: "yAxis-boolean",
        borderWidth: 0,
        color: colorArray[colorIndex],
        borderColor: colorArray[colorIndex],
        data: []
      }
      boolFlagSeriesData.push(JsonObj)
      for (let j = 0; j < flagSeriesData[i].data.length - 1; j++) {
        let _value, _color, _description = '';

        if ((flagSeriesData[i].data[j])[1] !== null) {
          if ((flagSeriesData[i].data[j])[1] > 0) {
            _value = true
            _color = colorArray[colorIndex]
            _description = "true"
          } else {
            _value = false
            _color = `${colorArray[colorIndex]}33`
            _description = "false"
          }
        } else {

          _value = false
          _color = `${colorArray[colorIndex]}33`
          _description = "false"
        }

        const dataObj = {
          x: this.getDateInMillisec((flagSeriesData[i].data[j])[0]),
          x2: this.getDateInMillisec((flagSeriesData[i].data[j + 1])[0]),
          y: i,
          value: _value,
          color: _color,
          description: _description
        }
        boolFlagSeriesData[i].data.push(dataObj)
      }

    }

    for (let i = 0; i < boolValuesSeriesData.length; i++, colorIndex++) {
      boolValuesSeriesData[i] = Object.assign(boolValuesSeriesData[i], {
        type: "line",
        yAxis: "yAxis-numeric",
        color: colorArray[colorIndex]
      });
      delete boolValuesSeriesData[i].showInNavigator;
    }

    const chartOption: any = {
      time: {
        useUTC: true
      },
      accessibility: {
        enabled: false
      },
      chart: {
        zoomType: "x",
        panKey: "shift",
        panning: {
          enabled: true,
          type: "x"
        }
      },
      legend: {
        itemMarginTop: 10
      },
      plotOptions: {
        series: {
          turboThreshold: 0,
          connectNulls: false,
          lineWidth: 1,
          states: {
            inactive: {
              opacity: 1
            }
          }
        },
        xrange: {
          borderRadius: 0,
          centerInCategory: true,
          grouping: false,
          pointWidth: undefined,
          pointPadding: 0.05,
          groupPadding: 0,
          colorByPoint: false
        }
      },
      title: {
        text: this.translate.instant(this.messages.selectedResourceData),
      },
      credits: {
        enabled: false
      },
      tooltip: {
        enabled: true,
        shared: true,
        hideDelay: 0,
        followPointer: true,
        useHTML: true,
        formatter: function (
          this: Highcharts.TooltipFormatterContextObject,
          tooltip: Highcharts.Tooltip
        ) {

          const dateTimeHtml = `${Highcharts.dateFormat('%d-%m-%Y %H:%M', Number(this.x))}<br/>`;
          let tooltipHtml = dateTimeHtml;
          if (this.points) {

            for (let i = 0; i < this.points.length; i++) {
              const point = this.points[i];
              //@ts-ignore
              const isNumericPoint: boolean = !point.x2;
              if (isNumericPoint) {
                const series = point.series;
                //@ts-ignore
                const valueSuffix = series.tooltipOptions?.valueSuffix || "";
                //@ts-ignore
                const valueDecimals = series.tooltipOptions?.valueDecimals;
                const valueHtml = `<b>${valueDecimals !== undefined
                  ? point.y.toFixed(valueDecimals)
                  : point.y
                  } ${valueSuffix}</b>`;
                //@ts-ignore
                const labelDataCell = `<td><span style="color:${series.color}">●</span> ${series.name}: </td>`;
                const valueDataCell = `<td style="text-align: right">${valueHtml}</td>`;
                tooltipHtml += `${labelDataCell}${valueDataCell}<br/>`;
              }
            }

            for (let i = 0; i < boolFlagSeriesData.length; i++) {
              const boolPoint = this.points.filter(p => p.series.name === boolFlagSeriesData[i].name);
              if (boolPoint.length > 0) {
                const booleanValue = boolPoint[0].point;
                const valueHtml = `<b>${booleanValue.value.toString()}</b>`;
                const labelDataCell = `<td><span style="color:${booleanValue.color}">●</span> ${boolFlagSeriesData[i].name}: </td>`;
                const valueDataCell = `<td style="text-align: right">${valueHtml}</td>`;
                tooltipHtml += `${labelDataCell}${valueDataCell}<br/>`;
              }
            }
          }

          return tooltipHtml;
        },
      },
      series: [...boolValuesSeriesData, ...boolFlagSeriesData],

      exporting: {
        buttons: {
          contextButton: {
            menuItems: Highcharts.defaultOptions.exporting.buttons.contextButton.menuItems.slice(0, 5) 
          }
        }
      },
      xAxis: {
        type: "datetime",
        crosshair: {
          snap: true
        }
      },
      yAxis: [
        {
          id: "yAxis-numeric", title: { text: "Numeric" },
          height: "55%"
        },
        {
          id: "yAxis-boolean",
          title: { text: '' },
          reversed: true,
          categories: boolCategory,
          height: "45%",
          top: "56%",
          offset: 0,
          gridLineWidth: 0,

        }
      ]
    }
    this.boolStock = new Chart(chartOption);


  }
  public enterFS(ele: any) {
    if (ele.requestFullscreen) {
      ele.requestFullscreen();
    } else if (ele.webkitRequestFullscreen) {
      ele.webkitRequestFullscreen();
    } else if (ele.mozRequestFullScreen) {
      ele.mozRequestFullScreen();
    } else if (ele.msRequestFullscreen) {
      ele.msRequestFullscreen();
    } else { }
  }
  public getDateInMillisec(dt) {
    const alarmDate = new Date(dt);
    const dateInMillisec = alarmDate.getTime();
    return dateInMillisec;
  }
  public getLatestTelemetryData(cooler_uid: string) {
    this.baseService.GET(`/Telemetry/LatestDataSeriesFromDFL/${cooler_uid}`).subscribe((result: ITelemetryLatestData[]) => {
      this.latestTelemetryData = result;
      if (this.latestTelemetryData) {
        for (const latestTelemetryDaton of this.latestTelemetryData) {
          this.selectedResources.push(latestTelemetryDaton.resourceName);
          if (latestTelemetryDaton.unit === 'flag') {
            this.flagResources.push(latestTelemetryDaton.resourceName);
          } else {
            this.unitResources.push(latestTelemetryDaton.resourceName);
          }
        }
        if (this.selectedResources.length >= 8) {
          this.selectedResources.length = 8;
        } else {
          this.selectedResources.length = this.latestTelemetryData.length;
        }
        if (this.latestTelemetryData.length < 10) {
          this.isPaginationL = false;
        }
        if (this.showDetails !== undefined && this.showDetails === true) {
          this.GetTelemetryData_day();
        }

        this.showDetails = false;
      }
      if (!this.latestTelemetryData) {
        this.noData = true;
      }
    })
  }

  public getSingleResourceDayTelmetryData(selResource) {
    this.selectedResources = [];
    this.selResourceData = selResource;
    this.selectedResources.push(selResource);
    this.GetTelemetryData_day();
  }
  public GetTelemetryData_day() {
    this.telemetryData = [];
    this.noDataG = false;
    this.getMyStyles();
    this.isPaginationD = true;

    this.isDay = true;
    this.isWeek = false;
    this.isMonth = false;

    const sDate = new Date(this.selectedDate);
    const eDate = new Date(this.selectedDate);
    this.request = {
      'deviceId': this.cooler_uid,
      'fromDate': UtilService.FormatDate(this.addDays(sDate, 1)),
      'toDate': UtilService.FormatDate(this.addDaysIncr(eDate, 1)),
      'resourceList': this.selectedResources
    };
    this.baseService.POST(this.dataSeriesFrmDflApi, this.request).subscribe((result) => {
      this.telemetryData = result;
      this.telemetryGridcols = [];
      this.telemetryGridcols.push({ field: 'timeStamp', header: this.labels.tableHeaderTimeStamp });
      if (this.telemetryData) {
        if (this.telemetryData.length === 0) {
          this.noDataG = true;
        }
        if (this.telemetryData.length > 0) {
          for (const dataSery of this.telemetryData[0].dataSeries) {
            this.telemetryGridcols.push({ field: 'value', header: dataSery.resourceName });
          }
          this.seriesData = new Array<any>();
          this.seriesData = this.GetDataSeriesForGraph(this.telemetryData);

          this.flagSeriesData = this.seriesData.filter((p) => this.flagResources.includes(p.name));
          this.valuesSeriesData = this.seriesData.filter((p) => this.unitResources.includes(p.name));

          this.InitGraph(this.valuesSeriesData, this.flagSeriesData);
        }
        if (this.telemetryData.length < 10) {
          this.isPaginationD = false;
        }
        if (this.selResourceData !== "" && window.innerWidth < 1200) { // for mobile view
          this.resourcecols = [
            { field: 'timeStamp', header: this.labels.tableHeaderTimeStamp },
            { field: 'value', header: this.labels.tableHeaderValue }
          ];
          const resData = this.seriesData.filter(p => p.name === this.selResourceData);
          if (resData.length !== 0) {
            this.singleResourceDayData = ((resData)[0].data).sort((a, b) => b[0] - a[0]);
            this.singleResourceDayDataNotExists = false;
          } else {
            this.singleResourceDayDataNotExists = true;
          }
          this.showResourceData = true;

        }
        this.enableExport = false;
      }
    }, err => {
      this.messageService.add({ severity: 'error', summary: 'Error', detail: this.messages.telemetryDataFetchError, key: 'error' });
    });
  }

  public GetTelemetryData_week() {
    this.telemetryData = [];
    this.noDataG = false;
    this.getMyStylesByWeek();
    this.isPaginationD = true;

    this.isDay = false;
    this.isWeek = true;
    this.isMonth = false;

    const sDate = new Date(this.selectedDate);
    const eDate = new Date(this.selectedDate);
    this.request = {
      'deviceId': this.cooler_uid,
      'fromDate': UtilService.FormatDate(this.addDays(sDate, 7)),
      'toDate': UtilService.FormatDate(this.addDaysIncr(eDate, 1)),
      'resourceList': this.selectedResources
    };
    this.baseService.POST(this.dataSeriesFrmDflApi, this.request).subscribe((result) => {
      this.telemetryData = result;
      this.telemetryGridcols = [];
      this.telemetryGridcols.push({ field: 'timeStamp', header: this.labels.tableHeaderTimeStamp });
      if (this.telemetryData) {
        if (this.telemetryData.length === 0) {
          this.noDataG = true;
        }
        if (this.telemetryData.length > 0) {
          for (const dataSery of this.telemetryData[0].dataSeries) {
            this.telemetryGridcols.push({ field: 'value', header: dataSery.resourceName });
          }

          this.seriesData = new Array<any>();
          this.seriesData = this.GetDataSeriesForGraph(this.telemetryData);

          this.flagSeriesData = this.seriesData.filter((p) => this.flagResources.includes(p.name));
          this.valuesSeriesData = this.seriesData.filter((p) => this.unitResources.includes(p.name));

          this.InitGraph(this.valuesSeriesData, this.flagSeriesData);
        }
        if (this.telemetryData.length < 10) {
          this.isPaginationD = false;
        }
      }
    },
      err => {
        this.messageService.add({ severity: 'error', summary: 'Error', detail: this.messages.telemetryDataFetchError, key: 'error' });
      })
  }

  public GetTelemetryData_month() {
    this.date_selected = this.selectedDate;
    this.telemetryData = [];
    this.noDataG = false;
    this.getMyStylesByMonth();
    this.isPaginationD = true;

    this.isDay = false;
    this.isWeek = false;
    this.isMonth = true;

    const requestArray = [];

    const batchMonthlyRequests = this.GetMonthlyDataBatchRequests();

    batchMonthlyRequests.forEach(element => {
      requestArray.push(this.baseService.POST(this.dataSeriesFrmDflApi, element));
    });

    forkJoin(requestArray).pipe(delay(5000)).subscribe(results => {
      if (results !== null && results.length > 0) {
        this.response = results;
        this.response.forEach(arr => {
          this.telemetryData.push(...arr);
        });
        this.SortTelemtrydata(this.telemetryData);
        this.telemetryGridcols = [];
        this.telemetryGridcols.push({ field: 'timeStamp', header: this.labels.tableHeaderTimeStamp });
        if (this.telemetryData && this.telemetryData.length === 0) {
          this.noDataG = true;
        }
        if (this.telemetryData && this.telemetryData.length > 0) {
          for (const dataSery of this.telemetryData[0].dataSeries) {
            this.telemetryGridcols.push({ field: 'value', header: dataSery.resourceName });
          }

          this.seriesData = new Array<any>();
          this.seriesData = this.GetDataSeriesForGraph(this.telemetryData);

          this.flagSeriesData = this.seriesData.filter((p) => this.flagResources.includes(p.name));
          this.valuesSeriesData = this.seriesData.filter((p) => this.unitResources.includes(p.name));
          this.InitGraph(this.valuesSeriesData, this.flagSeriesData);
        }
        if (this.telemetryData && this.telemetryData.length < 10) {
          this.isPaginationD = false;
        }

      }

    },
      err => {
        this.messageService.add({ severity: 'error', summary: 'Error', detail: this.messages.telemetryDataFetchError, key: 'error' });
      })
  }

  SortTelemtrydata(data: any) {
    return data.sort((a: any, b: any) => {
      return <any>new Date(b.timeStamp) - <any>new Date(a.timeStamp);
    });
  }

  public GetDataSeriesForGraph(graphData: ITelemetryData[]) {
    const Tdata = graphData.slice().reverse();
    const resources: any[] = [];
    for (const dataSery of Tdata[0].dataSeries) {
      resources.push({
        name: dataSery.resourceName,
        showInNavigator: true,
        data: []
      });
    }
    for (const tdaton of Tdata) {
      for (let k = 0; k < resources.length; k++) {
        if (resources[k].name === tdaton.dataSeries[k].resourceName) {
          resources[k].data.push([new Date(tdaton.timeStamp).getTime(), tdaton.dataSeries[k].value])
        }
      }
    }
    return resources;
  }

  getMyStyles() {

    return {

      'border-bottom': this.isDay ? this.borderBottom : '',
      'text-decoration': 'none',
      'padding-bottom': this.isDay ? '10px' : ''
    };
  }

  getMyStylesByWeek() {

    return {

      'border-bottom': this.isWeek ? this.borderBottom : '',
      'text-decoration': 'none',
      'padding-bottom': this.isWeek ? '10px' : ''
    };
  }

  getMyStylesByMonth() {

    return {

      'border-bottom': this.isMonth ? this.borderBottom : '',
      'text-decoration': 'none',
      'padding-bottom': this.isMonth ? '10px' : ''
    };
  }

  public ExportToExcel(telemetrydata: ITelemetryData[]) {
    const tempDate = new Date(this.selectedDate);
    this.isLoading = true;
    const request = {
      'deviceId': this.cooler_uid,
      'resourceList': this.selectedResources,
      'toDate': UtilService.FormatDate(this.addDaysIncr(this.selectedDate, 1))
    };
    if (this.isDay) {
      request['fromDate'] = UtilService.FormatDate(tempDate.setDate(tempDate.getDate() - 1));
    }
    if (this.isWeek) {
      request['fromDate'] = UtilService.FormatDate(tempDate.setDate(tempDate.getDate() - 7));
    }
    if (this.isMonth) {
      UtilService.FormatDate(tempDate.setMonth(tempDate.getMonth() - 1));
      request['fromDate'] = UtilService.FormatDate(tempDate.setDate(tempDate.getDate() + 1))
    }

    this.baseService.DOWNLOAD("/Telemetry/ExportDataSeriesFromDFL", request).subscribe((result) => {
      const fileName = `Telemetry_${this.cooler_uid}.xlsx`;
      const blob = new Blob([result], { type: "application/octet-stream" });
      saveAs(blob, fileName);
      this.isLoading = false;
    });


  }

  public onSelect(selectedDt: any) {
    if (this.isDay === true && this.isMonth === false && this.isWeek === false) {
      this.GetTelemetryData_day();
    }
    else if (this.isMonth === true && this.isDay === false && this.isWeek === false) {
      this.GetTelemetryData_month();
    }
    else if (this.isWeek === true && this.isDay === false && this.isMonth === false) {
      this.GetTelemetryData_week();
    }
    else {
      //empty condition block
    }
  }

  public handleData(e: any) {
    this.notChanged = false;
    if (this.selectedResources.length > 8) {
      this.messageService.add({ severity: 'warn', summary: 'Warning', detail: 'Maximum of 8 resources allowed to select', key: 'error' });
      this.selectedResources.pop();
      return;
    }
    this.enableExport = true;
  }

  public Get_TimeseriesData() {
    this.GetTelemetryData_day();
  }

  public editTag() {
    this.editFlag = !this.editFlag;
  }

  public change_grid() {
    this.chartogrid = true;
  }

  public change_graph() {
    this.chartogrid = false;
    if (this.isDay == true) {
      this.GetTelemetryData_day();
    }
    else if (this.isWeek == true) {
      this.GetTelemetryData_week();
    }
    else if (this.isMonth == true) {
      this.GetTelemetryData_month();
    }
  }

  public addDays(dt: Date, days: number) {
    const d = dt.setDate(dt.getDate() - days);
    return new Date(UtilService.FormatDate(d));
  }

  public addDaysIncr(dt: Date, days: number) {
    const d = dt.setDate(dt.getDate() + days);
    return new Date(UtilService.FormatDate(d));
  }

  getdateDiff(a: any, b: any) {
    return Math.abs(a - b);
  }

  private GetMonthlyDataBatchRequests(): any[] {
    const chunks = [];
    const chunkSize = 15;
    const selectedDate = new Date(this.selectedDate);
    const startDate = new Date(this.selectedDate);
    startDate.setMonth(startDate.getMonth() - 1);
    startDate.setDate(startDate.getDate() + 1);
    const endDate = new Date(this.addDaysIncr(selectedDate, 1));
    const current = new Date(startDate.getTime());
    do {
      const start = new Date(current.getTime());
      const d2 = new Date(current.setDate(current.getDate() + chunkSize));
      let end = d2 <= endDate ? new Date(d2.setDate(d2.getDate() - 1)) : endDate;
      if (current < endDate) {
        end = this.addDaysIncr(end, 1);
      }
      chunks.push({
        'deviceId': this.cooler_uid,
        'fromDate': UtilService.FormatDate(start),
        'toDate': (current.getTime() === endDate.getTime()) ?
          UtilService.FormatDate(this.addDaysIncr(end, 1)) :
          UtilService.FormatDate(end),
        'resourceList': this.selectedResources
      });
    } while (current <= endDate);

    return chunks;
  }


  ngOnDestroy() {
    this.subscription.unsubscribe();
  }
  EditAlarms(alarmRuleId, unit, resourceName) {

    this.formInvalid = false;
    this.contentHeader = this.labels.updateRule;
    this.isLoading = true;
    this.isEdit = true;

    this.baseService.GET(`/Alarm/AlarmRuleByRuleId/${alarmRuleId}`).subscribe(async (ruleData: IRulesDetail) => {
      this.baseService.GET(`/Device/DeviceSamplingInterval/${this.telemetryService.cooler_id}`).subscribe((multipleNumber: number) => {
        this.delayMultiple = multipleNumber;
        this.currentRule = ruleData[0];
        this.alarmRuleName = ruleData[0].alarmName;
        this.selectedContrl = this.telemetryService.controllerTypeName;
        this.selectedDongleUId = this.telemetryService.dongleUId;
        this.unit = unit;
        if (unit === "flag") {
          this.showAlarmWhen = true;
          this.selectedalarmWhen = ruleData[0].highlimit;
        } else {
          this.showAlarmWhen = false;
          this.maxVal = ruleData[0].highlimit;
          this.minVal = ruleData[0].lowlimit;
        }
        this.defaultLoggedInEmail = this.auth.authenticatedUserEmail;
        this.notifiedTo = ruleData[0].notifiedTo;
        
        // if (this.notifiedTo && this.notifiedTo.includes(';')) {
        //   this.displayInputBoxs = true;
        //   this.emialIds = this.notifiedTo.split(';').map(e => e.trim()).filter(e => !!e);
        //   this.notifiedTo = '';
        // } else if (this.notifiedTo) {
        //   this.emialIds = [this.notifiedTo.trim()];
        // } else {
        //   this.emialIds = [];
        // }
        if (this.notifiedTo) {
          if (this.notifiedTo.includes(';')) {
            this.displayInputBoxs = true;
            this.emialIds = this.notifiedTo.split(';').map(e => e.trim()).filter(e => !!e);
            this.notifiedTo = '';
          } else {
            this.emialIds = [this.notifiedTo.trim()];
            this.displayInputBoxs = true;
            this.notifiedTo = '';
          }
        } else {
          this.emialIds = [];
        }
        this.severity = ruleData[0].severity;
        this.selectedRes = resourceName;
        this.isAlarmActive = ruleData[0].isActive;
        this.ruleId = ruleData[0].id;
        this.newRule.id = ruleData[0].id;
        this.SelectedResourceId = ruleData[0].resourceId;
        if (ruleData[0].delayTimer % this.delayMultiple === 0) {
          this.delay = ruleData[0].delayTimer;
        } else {
          this.delay = this.delayMultiple;
        }
        if(this.delay === 0){
          this.delay = null;
        }
        if (ruleData[0].notifiedToList !== undefined && ruleData[0].notifiedToList.length !== 0) {
          this.applyToNotifyName = ruleData[0].notifiedToList;
        }
        this.showAlarmModal = true;
        this.isLoading = false;

      });
    });

  }
  public AddAlarms(rowData,resourceName, unit, resourceId, index, event) {
    this.baseService.GET(`/Device/DeviceSamplingInterval/${this.telemetryService.cooler_id}`).subscribe((multipleNumber: number) => {
      this.delayMultiple = multipleNumber;
      const target = event.target || event.srcElement || event.currentTarget;
      if (target.src.includes("bell-icon-fill.png")) {
        this.EditAlarms(target.attributes.getNamedItem("data-target").nodeValue, unit, resourceName)
      }
      else {
        this.colIndex = index;
        this.formInvalid = true;
        this.ResetRuleObject(resourceName, resourceId);
        this.contentHeader = this.labels.addRule;
        this.isEdit = false;
        this.isAlarmActive = true;
        this.unit = unit;
        if (unit === "flag") {
          this.showAlarmWhen = true;
        } else {
          this.showAlarmWhen = false;
        }
        // this.notifiedTo = this.auth.authenticatedUserEmail;
        this.defaultLoggedInEmail = this.auth.authenticatedUserEmail;
        this.showAlarmModal = true;
        
        
      }
    });
  }


  public ResetRuleObject(resourceName, resourceId) {
    this.selectedContrl = this.telemetryService.controllerTypeName;
    this.selectedDongleUId = this.telemetryService.dongleUId;
    this.selectedRes = resourceName;
    this.SelectedResourceId = resourceId;
    this.newRule = {
      id: 0, alarmName: '', coolerId: 0, resourceId: resourceId, highlimit: 0,
      lowlimit: 0, notifiedTo: '', notifiedToList: [], severity: 0, isActive: true,
      addedBy: this.auth.authenticatedUserId, delayTimer: null
    };
    this.minVal = null;
    this.maxVal = null;
    this.notifiedTo = '';
    this.severity = 1;
    this.alarmRuleName = '';
    // this.applyToNotifyName = [];
    this.delay = null;
    this.selectedalarmWhen = 0;
    this.emialIds = [];
  }
  public NotifyToSelectionChange($event: Event) {
    this.validateForm();
  }
  public ApplyToSelectionChange() {
    this.validateForm();
  }
  private GetUserApiCall(): Observable<any> {
    let apiUrl = '';
    this.CanOnlySelectThemself = false;
    switch (this.auth.authenticatedRoleCd) {
      case rolesdef.master:
        apiUrl = '/User/AllUsers';
        break;
      case rolesdef.enduser:
        apiUrl = '/User/AllChildUsersByEndUser';
        break;
      case rolesdef.cuserW:
        apiUrl = '/User/AllChildUsersByEndUser';
        break;
      default:
        this.CanOnlySelectThemself = true;
        break;
    }
    return !this.CanOnlySelectThemself ? this.baseService.GET(apiUrl) : EMPTY;
  }
  async GetUserDetails() {
    const result = await this.GetUserApiCall().toPromise();
    if (result) {
      if (result && result.length > 0) {
        result.forEach(item => {
          this.applyToNotifyToData.push({
            id: item.id,
            name: `${item.name} - [${item.email}]`
          });
        });
      } else {
        this.CanOnlySelectThemself = true;
      }
    }
  }
  private SaveOrUpdateAlarmRule(rule: IRule) {
    let apiUrl = '';
    const customHeaders = {};
    let alarmRuleAddUpdateObs;

    if (this.isEdit) {
      apiUrl = "/Alarm/EditAlarm";
      alarmRuleAddUpdateObs = this.baseService.PatchWithHeaders(apiUrl, customHeaders, rule);
    }
    else {
      apiUrl = "/Alarm/AddAlarmRule";
      alarmRuleAddUpdateObs = this.baseService.PostWithHeaders(apiUrl, {}, rule);
    }

    alarmRuleAddUpdateObs.subscribe((result) => {
      if (result === null || result > 0) {
        this.showAlarmModal = false;
        this.isLoading = false;
        let elem: Element = null;
        if (this.isEdit === true) {
          this.messageService.add({ severity: 'success', summary: this.translate.instant(this.messages.success), detail: `Rule ${rule.id} ${this.translate.instant(this.messages.ruleUpdate)}`, key: 'success' });
        }
        else {
          elem = document.getElementById(`AddAlrm${this.colIndex}`);
          if (elem !== null) {
            elem.setAttribute("src", "assets/bell-icon-fill.png");
            elem.setAttribute("data-target", result);
          }
          this.messageService.add({ severity: 'success', summary: this.translate.instant(this.messages.success), detail: `Rule ${result} ${this.translate.instant(this.messages.ruleAdd)}`, key: 'success' });
        }
        return;
      }
      if (result.status === 400) {
        this.messageService.add({ severity: 'error', summary: this.translate.instant(this.messages.badRequest), detail: this.translate.instant(this.messages.invalidInput), key: 'error' });
      } else {
        this.messageService.add({ severity: 'error', summary: this.translate.instant(this.messages.error), detail: this.translate.instant(this.messages.errorAdd), key: 'error' });
      }
    }, (error) => {
      this.isLoading = false;
      this.showAlarmModal = false;
      switch (error.error) {
        case this.messages.invalidAlarmRuleName:
          this.messageService.add({ severity: 'error', summary: this.translate.instant(this.messages.error), detail: this.translate.instant(this.messages.invalidAlarmRuleName), key: 'error' });
          break;
        case this.messages.duplicateAlarmName:
          this.messageService.add({ severity: 'error', summary: this.translate.instant(this.messages.error), detail: this.translate.instant(this.messages.duplicateAlarmName), key: 'error' });
          break;
        case this.messages.invalidResourceMap:
          this.messageService.add({ severity: 'error', summary: this.translate.instant(this.messages.error), detail: this.translate.instant(this.messages.invalidResourceMap), key: 'error' });
          break;
        case this.messages.invalidEmailAlarmRule:
          this.messageService.add({ severity: 'error', summary: this.translate.instant(this.messages.error), detail: this.translate.instant(this.messages.invalidEmailAlarmRule), key: 'error' });
          break;
        case this.messages.noUserAccessAlarmRule:
          this.messageService.add({ severity: 'error', summary: this.translate.instant(this.messages.error), detail: this.translate.instant(this.messages.noUserAccessAlarmRule), key: 'error' });
          break;
        case this.messages.invalidDelay:
          this.messageService.add({ severity: 'error', summary: this.translate.instant(this.messages.error), detail: this.translate.instant(this.messages.invalidDelay), key: 'error' });
          break;
        case this.messages.invalidCooler:
          this.messageService.add({ severity: 'error', summary: this.translate.instant(this.messages.error), detail: this.translate.instant(this.messages.invalidCooler), key: 'error' });
          break;
        default:
          this.messageService.add({ severity: 'error', summary: this.translate.instant(this.messages.error), detail: this.translate.instant(this.messages.errorAdd), key: 'error' });
          break;
      }
    });
  }
  public closeModal() {
    this.showResourceData = false;
    this.showAlarmModal = false;
    this.isLoading = false;
  }
  public validateForm() {
    console.log('validateForm', this.minVal, this.maxVal, this.notifiedTo)
    if (this._validateService.requiredElement(this.alarmRuleName, 'Alarm Name', 1, 500) === '' &&
      (this._validateService.requiredElement(String(this.minVal), 'Min Limit', 1, 10) === '' || this.minVal === null) &&
      (this._validateService.requiredElement(String(this.maxVal), 'Max Limit', 1, 10) === '' || this.maxVal === null) &&
      (this._validateService.multiEmailElement(this.notifiedTo, 'Notified Email To') === '' || (this.CanOnlySelectThemself ||
        this.defaultLoggedInEmail))
    ) {
      if (this.delay !== null && this.delay < 0) {
        this.delayLimitNonPostiveError = this.messages.invalidDelay;
        this.formInvalid = true
        return;
      } else {
        if (this.delay % this.delayMultiple !== 0) {
          this.delay = this.delayMultiple;
        }
        this.delayLimitNonPostiveError = '';
      }
      this.formInvalid = false
    }
    else { this.formInvalid = true };
  }

  public SaveRule(txtNotify: any, txtAlarmName: any) {
    if (this.alarmRuleName === '') {
      this.messageService.add({ severity: 'error', summary: this.translate.instant(this.messages.invalidRule), detail: this.translate.instant(this.messages.invalidRuleDetail), key: 'error' });
      txtAlarmName.focus();
    }
    else if (!this.showAlarmWhen && !UtilService.IsValidFloat(this.minVal)) {
      this.messageService.add({ severity: 'error', summary: this.translate.instant(this.messages.invalidMin), detail: this.translate.instant(this.messages.invalidMinDetail), key: 'error' });
    }
    else if (!this.showAlarmWhen && !UtilService.IsValidFloat(this.maxVal)) {
      this.messageService.add({ severity: 'error', summary: this.translate.instant(this.messages.invalidMax), detail: this.translate.instant(this.messages.invalidMaxDetail), key: 'error' });
    }
    else if (this.delay !== null && this.delay < 0) {
      this.messageService.add({ severity: 'error', summary: this.translate.instant(this.messages.invalidDelay), detail: this.translate.instant(this.messages.invalidDelay), key: 'error' });
    }
     else if (this.notifiedTo !== '' && !UtilService.IsValidMultiEmail(this.notifiedTo)) {
      this.messageService.add({ severity: 'error', summary: this.translate.instant(this.messages.invalidEmail), detail: this.translate.instant(this.messages.notValidEmail), key: 'error' });
      txtNotify.focus();
    }
    else if (this.emialIds.some(e => !e || e.trim() === '')) {
      this.messageService.add({ severity: 'error', summary: this.translate.instant(this.messages.notEmptyEmail), detail: this.translate.instant(this.labels.enterValidEmailAddress), key: 'error' });
    } else {

      //Building Rule Object starts
      this.newRule.alarmName = this.alarmRuleName;
      this.newRule.coolerId = this.telemetryService.cooler_id;
      this.newRule.resourceId = this.SelectedResourceId;

      if (this.showAlarmWhen) {
        this.newRule.highlimit = this.selectedalarmWhen;
        this.newRule.lowlimit = null;
      } else {
        this.newRule.highlimit = this.maxVal;
        this.newRule.lowlimit = this.minVal;
      }
      this.newRule.severity = this.severity;
      this.newRule.notifiedTo = this.notifiedTo;
      this.newRule.notifiedToList = [];
      if(this.emialIds.length > 0){
       this.newRule.notifiedTo = this.emialIds.filter(e => !!e && e.trim() !== '').join(';');
      }
      for (const item in this.applyToNotifyName) {
        if (this.applyToNotifyName.hasOwnProperty(item)) {
          this.newRule.notifiedToList.push(Number(this.applyToNotifyName[item]));
        }
      }
      if(this.delay === 0){
        this.delay = null;
      }
      this.newRule.delayTimer = this.delay;
      this.newRule.isActive = this.isEdit ? this.isAlarmActive : true;
      this.isLoading = true;
      this.SaveOrUpdateAlarmRule(this.newRule);

    }
  }

  showInputboxs(){
    this.displayInputBoxs = true;
    const email = this.notifiedTo?.trim();
    this.emialIds.push(email);
    this.notifiedTo = '';
  }

  trackByIndex(index: number, obj: any): any {
    return index;
  }

  removeEmail(idx: number) {
    this.emialIds.splice(idx, 1);
  }

  

  increaseDelay() {
    if (!this.delay || this.delay < this.delayMultiple) {
    this.delay = this.delayMultiple;
    } else {
      // Round up to the next multiple of delayMultiple
      this.delay = Math.ceil((this.delay + 1) / this.delayMultiple) * this.delayMultiple;
    }
  }

  decreaseDelay() {
    // this.delay = Math.max(1, Math.floor((this.delay || 0) / this.delayMultiple));
    if (!this.delay || this.delay <= this.delayMultiple) {
      this.delay = null;
    } else {
      this.delay = this.delay - this.delayMultiple;
    }
  }

}
